import { Outlet } from 'react-router';
import { useMe } from '../api/me';
import { InlineError } from './InlineError';
import { InteractiveSessions } from './InteractiveSessions';
import { JobsTable } from './JobsTable';

export function JobsListLayout() {
  const { data: me, error, isPending, refetch } = useMe();

  return (
    <>
      {isPending && <p className="px-6 py-10 text-sm text-slate-500">Loading…</p>}
      {/* A non-401 `/me` failure otherwise stranded the user with no recovery. (A 401
          is terminal — `apiFetch` has already navigated to Okta, so this never renders
          for that case.) The inline-error-with-Retry convention makes a transient
          failure recoverable in place. */}
      {error && (
        <InlineError
          heading="Couldn't load user"
          error={error}
          onRetry={() => void refetch()}
          className="m-6"
        />
      )}
      {me && (
        <>
          <InteractiveSessions userId={me.id} />
          <JobsTable userId={me.id} />
        </>
      )}
      {/* Drawer overlays via nested route (jobs/:id) */}
      <Outlet />
    </>
  );
}
